import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { iconButtonConfig, tokens } from '../../constants';
import { getCurrentEventControlState } from '../../utils';
var getContainerBasicStyle = () => {
  return {
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
  };
};
var getIconLabelPositionStyle = props => {
  var flexDirection = props.labelPosition === 'right' ? 'row' : 'column';
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection
  };
};
var getIconContainerStyle = (props, controlState) => {
  var _a, _b, _c, _d, _e, _f, _g;
  var type = props.type,
    label = props.label,
    labelPosition = props.labelPosition,
    noBgColor = props.noBgColor,
    noContainer = props.noContainer;
  var buttonTypeControlState = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b.controlState) === null || _c === void 0 ? void 0 : _c[controlState];
  var iconButtonSize = (_g = (_f = (_e = (_d = props === null || props === void 0 ? void 0 : props.config) === null || _d === void 0 ? void 0 : _d[type]) === null || _e === void 0 ? void 0 : _e.size) === null || _f === void 0 ? void 0 : _f[props.size]) === null || _g === void 0 ? void 0 : _g.iconButtonSize;
  var spacing = tokens.spacing;
  var marginRight = spacing.SPACING_8;
  var marginBottom = spacing.SPACING_4;
  var addPaddingForImage = controlState !== 'hover' && (props === null || props === void 0 ? void 0 : props.variant) === 'image' && !noBgColor;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, !noBgColor && {
    backgroundColor: buttonTypeControlState === null || buttonTypeControlState === void 0 ? void 0 : buttonTypeControlState.buttonColor,
    borderWidth: buttonTypeControlState === null || buttonTypeControlState === void 0 ? void 0 : buttonTypeControlState.borderWidth,
    borderColor: buttonTypeControlState === null || buttonTypeControlState === void 0 ? void 0 : buttonTypeControlState.borderColor
  }), !noContainer && {
    width: iconButtonSize,
    height: iconButtonSize
  }), {
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: iconButtonSize * 2
  }), addPaddingForImage && {
    padding: 1
  }), label && Object.assign({}, labelPosition == 'right' ? {
    marginRight
  } : {
    marginBottom
  }));
};
export var getLabelTypes = size => {
  var labelTypes = {
    sm: 'body-para-xs',
    md: 'body-para-xs',
    lg: 'body-para-sm'
  };
  return labelTypes === null || labelTypes === void 0 ? void 0 : labelTypes[size];
};
var getNotifierStyle = (props, controlState) => {
  var size = props.size,
    notifierProps = props.notifierProps,
    noBgColor = props.noBgColor,
    noContainer = props.noContainer;
  var isHovering = controlState === 'hover' && !noBgColor;
  var safeSpacing = isHovering ? -1 : 0;
  if (noContainer) safeSpacing = isHovering ? -5 : -4;
  var positions = {
    sm: {
      top: noContainer ? 1 : isHovering ? 1 : 2,
      right: noContainer ? 3 : isHovering ? 1 : 2
    },
    md: {
      top: noContainer ? 1 : isHovering ? 1 : 2,
      right: noContainer ? 3 : isHovering ? 3 : 4
    },
    lg: {
      top: noContainer ? -2 : isHovering ? 0 : 1,
      right: noContainer ? 0 : isHovering ? 2 : 3
    }
  };
  return Object.assign({
    position: 'absolute'
  }, (notifierProps === null || notifierProps === void 0 ? void 0 : notifierProps.hasDot) ? positions === null || positions === void 0 ? void 0 : positions[size] : {
    top: safeSpacing,
    right: safeSpacing
  });
};
var getInfoTagStyle = (props, controlState) => {
  var size = props.size;
  var isHovering = controlState === 'hover';
  var positions = {
    sm: {
      top: isHovering ? -7 : -6
    },
    md: {
      top: isHovering ? -7 : -6
    },
    lg: {
      top: isHovering ? -9 : -8
    }
  };
  return Object.assign({
    position: 'absolute',
    alignSelf: 'center'
  }, positions === null || positions === void 0 ? void 0 : positions[size]);
};
export var getIconButtonStyles = (props, event) => {
  var _a, _b, _c;
  var controlState = props.controlState;
  var type = (_a = props.config) === null || _a === void 0 ? void 0 : _a[props === null || props === void 0 ? void 0 : props.type];
  var _controlState = getCurrentEventControlState(event, controlState);
  var color = (_c = (_b = type === null || type === void 0 ? void 0 : type.controlState) === null || _b === void 0 ? void 0 : _b[_controlState]) === null || _c === void 0 ? void 0 : _c.textColor;
  return StyleSheet.create({
    container: getContainerBasicStyle(),
    iconContainer: getIconContainerStyle(props, _controlState),
    iconPosition: getIconLabelPositionStyle(props),
    notifier: getNotifierStyle(props, _controlState),
    infoTag: getInfoTagStyle(props, _controlState),
    iconButtonLabel: {
      color,
      textAlign: 'center'
    }
  });
};
export var getIconButtonProps = (props, context) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(iconButtonConfig === null || iconButtonConfig === void 0 ? void 0 : iconButtonConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.iconButton) === null || _a === void 0 ? void 0 : _a[theme]);
  var size = (props === null || props === void 0 ? void 0 : props.size) || (configProps === null || configProps === void 0 ? void 0 : configProps.size);
  var type = (props === null || props === void 0 ? void 0 : props.type) || (configProps === null || configProps === void 0 ? void 0 : configProps.type);
  var controlState = (props === null || props === void 0 ? void 0 : props.disabled) && 'disabled' || (props === null || props === void 0 ? void 0 : props.selected) && 'selected' || (props === null || props === void 0 ? void 0 : props.controlState) || (configProps === null || configProps === void 0 ? void 0 : configProps.controlState);
  var iconPropsConfig = {
    height: (_e = (_d = (_c = (_b = configProps === null || configProps === void 0 ? void 0 : configProps.config) === null || _b === void 0 ? void 0 : _b[type]) === null || _c === void 0 ? void 0 : _c.size) === null || _d === void 0 ? void 0 : _d[size]) === null || _e === void 0 ? void 0 : _e.iconSize,
    width: (_j = (_h = (_g = (_f = configProps === null || configProps === void 0 ? void 0 : configProps.config) === null || _f === void 0 ? void 0 : _f[type]) === null || _g === void 0 ? void 0 : _g.size) === null || _h === void 0 ? void 0 : _h[size]) === null || _j === void 0 ? void 0 : _j.iconSize,
    color: (_o = (_m = (_l = (_k = configProps === null || configProps === void 0 ? void 0 : configProps.config) === null || _k === void 0 ? void 0 : _k[type]) === null || _l === void 0 ? void 0 : _l.controlState) === null || _m === void 0 ? void 0 : _m[controlState]) === null || _o === void 0 ? void 0 : _o.iconColor
  };
  var iconProps = (props === null || props === void 0 ? void 0 : props.iconProps) || iconPropsConfig;
  return Object.assign(Object.assign(Object.assign({
    theme
  }, configProps), props), {
    iconProps,
    controlState
  });
};